export default "You and your pirate crew go looking for treasure on an island. You have found a cave and a ship. But is there any treasure?";